export const getRandomArbitrary = (min, max) => {
  return Math.ceil(Math.random() * (max - min) + min);
};

export const bytesToSize = (bytes) => {
  const sizes = ["By", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 By";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  const value = Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  return value;
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Collator

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});
export const sortAlphaNum = (a, b) => {
  //return a > b;
  return collator.compare(a, b);
};

export const arrayToByIds = (array, key = "id") =>
  array.reduce((obj, item) => {
    obj[item[key]] = item;
    return obj;
  }, {});

export const makeCompositeId = (...parts) => parts.join("-");

export const arrayToAllIds = (array, key = "id") =>
  array.reduce(
    (arr, item) => (arr.includes(item[key]) ? arr : [...arr, item[key]]),
    [],
  );

// we use database for sorting!!!
//.sort((a, b) => a - b)
//.reverse();

export const arrayToByIdsAllIds = (array, key = "id") => [
  arrayToByIds(array, key),
  arrayToAllIds(array, key),
];

// Responses can arrive in a different order than their requests were sent
// (typing in a search field). Call the tracker when a request starts; the
// returned check tells whether it is still the most recent one.
export const createLatestRequestTracker = () => {
  let latestRequestId = 0;
  return () => {
    latestRequestId += 1;
    const requestId = latestRequestId;
    return () => requestId === latestRequestId;
  };
};
